/**
 * Yleiskuva → Kaikki näkymät: every participant and legacy screen, collapsed,
 * for checking or debugging. Workshop screens are normally opened from
 * Työpaja and Laitteet, where they run in the chain's context.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import { useTranslation } from '../../hooks/useTranslation.jsx';

// Current screens first; those kept only for old workshops after them.
const VIEWS = [
  { route: '/impactpath', key: 'impactPath' },
  { route: '/pivotpoints', key: 'pivotPoints' },
  { route: '/lenses', key: 'lenses' },
  { route: '/ratkaisut', key: 'solutions' },
  { route: '/raportti', key: 'report' },
  { route: '/impact-machine', key: 'impactMachine', legacy: true },
  { route: '/postit', key: 'postit', legacy: true },
  { route: '/weather', key: 'weather', legacy: true },
  { route: '/statmap', key: 'statmap', legacy: true },
];

const Details = styled.details`
  margin-top: 28px;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.75);

  summary { cursor: pointer; font-size: 14px; }
  ul { display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 6px 16px; margin: 12px 0 0; padding: 0; list-style: none; }
  a { color: #93c5fd; font-size: 13px; }
  small { color: rgba(255, 255, 255, 0.4); margin-left: 6px; }
`;

export default function AllViewsList({ instanceId }) {
  const { t } = useTranslation();
  return (
    <Details>
      <summary>{t('adminHome.allViews')}</summary>
      <ul>
        {VIEWS.map((v) => (
          <li key={v.route}>
            <Link to={`${v.route}?instance=${instanceId}`}>{t(`adminHome.view_${v.key}`)}</Link>
            <small>{v.route}{v.legacy ? ` · ${t('adminHome.legacy')}` : ''}</small>
          </li>
        ))}
      </ul>
    </Details>
  );
}
